import { Component, Input, OnInit } from '@angular/core';
import { MetaTagsService } from '@shared/services/meta-tags.service';
import { ActivatedRoute } from '@angular/router';
import { RoutesPath } from '@shared/routes-path';
import { BaseComponent } from '@shared/components/base.component';
import { Config } from '@shared/config';
import { environment } from 'src/environments/environment';

// declare var FB: any;

@Component({
  selector: 'app-ph-social-share',
  templateUrl: './ph-social-share.component.html',
  styleUrls: ['./ph-social-share.component.scss'],
})
export class PhSocialShareComponent extends BaseComponent implements OnInit {
  @Input() shareUrl: string;
  @Input() meta: any;
  title: string;
  description: string;
  url: string;
  image: string;
  features: string =
    'height=500,width=500;resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes';

  constructor(public metaTagsService: MetaTagsService, public route: ActivatedRoute) {
    super();
    this.getMetaData();
  }

  ngOnInit() {
    if (this.shareUrl) {
      this.url = this.shareUrl;
      this.description = this.meta.description;
      this.title = this.meta.title;
      this.image = this.meta.image;
    } else {
      const subQueryMap = this.route.queryParamMap.subscribe((data: any) => {
        const params = data.params;
        for (const key in params) {
          if (params.hasOwnProperty(key) && key === 'transactionId') {
            this.url = window.location.host + ['/' + RoutesPath.default.verified];
            this.description = Config.DEFAULT_META_TAGS.description;
            this.title = Config.DEFAULT_META_TAGS.title;
            this.image = Config.PUBLIC_SHARE_DEFAULT_IMAGE;
          }
        }
      });
      this.someSubscriptions.add(subQueryMap);
    }
  }

  getMetaData() {
    if (this.shareUrl) {
      this.url = this.shareUrl;
      this.description = this.meta.description;
      this.title = this.meta.title;
      this.image = this.meta.image;
      return;
    }
    this.url = this.metaTagsService.get('property="og:url"').content;
    this.description = this.metaTagsService.get('property="og:description"').content;
    this.title = this.metaTagsService.get('property="og:title"').content;
    this.image = this.metaTagsService.get('property="og:image"').content;
  }

  facebookShare() {
    this.getMetaData();
    window.open(
      'https://www.facebook.com/dialog/feed?' +
        'app_id=' +
        environment.FACEBOOK_APP_ID +
        '&name=' +
        this.title +
        '&picture=' +
        decodeURIComponent(this.image) +
        '&link=' +
        decodeURIComponent(this.url) +
        '&quote=' +
        this.title +
        '&description=' +
        this.description,
      'popUpWindow',
      this.features
    );
    // FB.ui({
    //   method: 'share_open_graph',
    //   action_type: 'og.shares',
    //   action_properties: JSON.stringify({
    //     object: {
    //       'og:url': this.url,
    //       'og:title': this.title,
    //       'og:description': this.description,
    //       'og:image': this.image
    //     }
    //   })
    // }, (response) => {
    //   // Action after response
    // });
  }

  twitterShare() {
    this.getMetaData();
    window.open(
      'https://twitter.com/intent/tweet?' +
        'url=' +
        decodeURIComponent(this.url) +
        '&text=' +
        this.title +
        '&hashtags=PlanetHeroes',
      'popUpWindow',
      this.features
    );
  }

  linkedInShare() {
    this.getMetaData();
    window.open(
      'https://www.linkedin.com/shareArticle?' +
        'mini=true' +
        '&url=' +
        decodeURIComponent(this.url) +
        '&title=' +
        this.title +
        '&source=PlanetHeroes',
      'popUpWindow',
      this.features
    );
  }

  qzoneShare() {
    this.getMetaData();
    window.open(
      'https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?' +
        'url=' +
        decodeURIComponent(this.url) +
        '&title=' +
        this.title +
        '&desc=' +
        this.description,
      'popUpWindow',
      this.features
    );
  }
}
